import { z } from 'zod';
import { catalogueStatusSchema } from '../../common/schemas/enum.schemas.js';
import { idParamSchema, uuidSchema } from '../../common/schemas/id.schemas.js';
import { paginatedSchema, paginationInputSchema, sortInputSchema } from '../../common/schemas/pagination.schemas.js';
export const segmentSchema = z.object({
    id: uuidSchema,
    name: z.string().min(1),
    description: z.string().nullable(),
    status: catalogueStatusSchema,
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const SEGMENT_SORT_FIELDS = ['name', 'status', 'createdAt'];
export const segmentSortBySchema = z.enum(SEGMENT_SORT_FIELDS);
export const listSegmentsInputSchema = z.object({
    ...paginationInputSchema.shape,
    ...sortInputSchema.shape,
    sortBy: segmentSortBySchema.default('name'),
    search: z.string().trim().min(1).optional(),
    status: catalogueStatusSchema.optional(),
});
export const listSegmentsOutputSchema = paginatedSchema(segmentSchema);
export const createSegmentInputSchema = z.object({
    name: z.string().trim().min(1, 'Name is required').max(128),
    description: z.string().trim().max(1000).optional(),
});
export const updateSegmentInputSchema = z.object({
    ...idParamSchema.shape,
    name: z.string().trim().min(1, 'Name is required').max(128).optional(),
    description: z.string().trim().max(1000).nullish(),
    status: catalogueStatusSchema.optional(),
});
//# sourceMappingURL=segments.schemas.js.map